<template>
  <div id="app">
    <keep-alive>
      <router-view></router-view>
    </keep-alive>
  </div>
</template>
<script>
export default {
  name: 'app'
}
</script>
<style>
  #app{height:inherit;}
</style>




// WEBPACK FOOTER //
// App.vue?7d23e04a